module.exports = __webpack_public_path__ + "static/media/ic_settings_24px.288f73ef.svg";